var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#081319;}")),React.createElement("path",{"d":"M7.14,14l-.87-.93S4.51,11.19,1,7.34L2.55,6.05l4.38,4.77L13.3,2,15,3.12Z","key":1})]);
}

Checkmark.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
